import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { deleteCar } from "../store/carSlice";
import { CarForm } from "./CarForm";
import { Filter } from "./ui/Filter";
import { Pagination } from "./ui/Pagination";
import { Button } from "./ui/Button/Button";
import { Link } from 'react-router-dom';
import { ResponsiveTable, StatusBadge } from './ui/table';

const PAGE_SIZE = 5;

export function UserList() {
  const users = useSelector((s) => s.users);

  console.log('users',users)
  const dispatch = useDispatch();

  const [filter, setFilter] = useState("");
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [page, setPage] = useState(1);

  // Filter by make/model/plate
  const filtered = users.filter((c) =>
    [c.full_name, c.username, c.email, c.phone_number, c.gender, c.date_of_birth, c.address, c.user_role]
      .join(" ")
      .toLowerCase()
      .includes(filter.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const start = (page - 1) * PAGE_SIZE;
  const pageItems = filtered.slice(start, start + PAGE_SIZE);

  const handleDelete = (user) => {
    if (window.confirm(`Are you sure you want to delete ${user.full_name}?`)) {
      dispatch(deleteUser(user.id));
    }
  };

  // Table configuration
  const columns = [
    {
      key: 'full_name',
      header: 'Full Name',
      primary: true,
      render: (value, item) => (
        <span className="text-sm font-medium text-gray-900 dark:text-gray-100">
          {value}
        </span>
      )
    },
    {
      key: 'username',
      header: 'Username',
      className: 'text-sm text-gray-700 dark:text-gray-300'
    },
    {
      key: 'email',
      header: 'Email',
      className: 'text-sm text-gray-700 dark:text-gray-300'
    },
    {
      key: 'phone_number',
      header: 'Phone Number',
      className: 'text-sm text-gray-700 dark:text-gray-300'
    },
    {
      key: 'gender',
      header: 'Gender',
      className: 'text-sm text-gray-700 dark:text-gray-300'
    },
    {
      key: 'date_of_birth',
      header: 'Date of Birth',
      className: 'text-sm text-gray-700 dark:text-gray-300'
    },
    {
      key: 'address',
      header: 'Address',
      className: 'text-sm text-gray-700 dark:text-gray-300'
    } ,
    {
      key: 'role',
      header: 'Role',
      className: 'text-sm text-gray-700 dark:text-gray-300'
    },
    {
      key: 'status',
      header: 'Status',
      render: (value) => {
        const getVariant = (status) => {
          switch (status?.toLowerCase()) {
            case 'active': return 'success';
            case 'inactive': return 'danger';
            default: return 'default';
          }
        };
        return <StatusBadge status={value} variant={getVariant(value)} />;
      }
    }     
  ];

  const actions = [
    {
      type: 'link',
      to: (item) => `/users/edit/${item.id}`,
      label: 'Edit',
      variant: 'primary'
    },
    {
      type: 'button',
      onClick: handleDelete,
      label: 'Delete',
      variant: 'danger'
    }
  ];

  const emptyState = (
    <div className="text-center py-12">
      <div className="mx-auto h-24 w-24 text-gray-400 dark:text-gray-600 mb-4">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"/>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 114 0M15 17a2 2 0 114 0"/>
        </svg>
      </div>
      <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">No cars found</h3>
      <p className="text-gray-600 dark:text-gray-400 mb-6">Get started by adding your first car to the fleet.</p>
      <Link to="/users/add">
        <Button variant="primary">Add Your First Car</Button>
      </Link>
    </div>
  );

  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        
          <Filter
            value={filter}
            onChange={(e) => {
              setFilter(e.target.value);
              setPage(1);
            }}
            placeholder="Search by make, model, or plate..."
          />
        
        <Link to="/users/add">
          <Button variant="primary" className="w-full sm:w-auto">
            Add User
          </Button>
        </Link>
      </div>

      
      {showForm && (
        <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-6">
          <CarForm editCar={editing} onDone={() => setShowForm(false)} />
        </div>
      )}

      {/* Table Section */}
     
          <ResponsiveTable
            data={pageItems}
            columns={columns}
            actions={actions}
            emptyState={emptyState}
          />
       

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center">
          <Pagination current={page} total={totalPages} onPageChange={setPage} />
        </div>
      )}
    </div>
  );
}